<template>
    <component
        :is="type"
        class="font-bold"
        :class="{
            'text-xl mb-4': type === 'h1',
            'text-lg mb-2': type === 'h2',
        }"
    >
        <slot></slot>
    </component>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'h1',
        },
    },
}
</script>
